import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import { CartContext } from "@overrides_venia/peregrine/context/cart";
import * as Sentry from "@sentry/react";
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    console.error(error, info);
    exponea.track("app_error", {
      event_type: "error",
      timestamp: Date.now(),
      location: window.location.href,
      cart_id: this.context[0].cartId,
      error_message: error.message,
      error_stack: error.stack
    });
    Sentry.withScope(scope => {
      scope.setLevel("fatal");
      scope.setTag("error_type", "fatal");
      scope.setTag("location", window.location.href);
      scope.setTag("cart_id", this.context[0].cartId);
      Sentry.captureException(error);
      var replay = Sentry.getReplay();
      replay.flush();
      Sentry.flush();
    });
  }
  render() {
    if (this.state.hasError) {
      var sentryReplay = Sentry.getReplay();
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Something went wrong."), sentryReplay !== null && sentryReplay !== void 0 && sentryReplay.getReplayId() ? /*#__PURE__*/React.createElement("h1", null, "Sentry Replay ID ", sentryReplay.getReplayId()) : null);
    }
    return this.props.children;
  }
}
_defineProperty(ErrorBoundary, "contextType", CartContext);